// Language gets stored in here, mostly controlled by <komoju-fields>.
declare let window: WindowWithKomojuGlobals;

const defaultLanguage = 'en';

type Queryable = {
  querySelectorAll: Document['querySelectorAll'];
};

export function broadcastLocaleChange(root: Queryable, locale: string) {
  root.querySelectorAll('komoju-i18n').forEach((element) => {
    const i18n = element as KomojuI18nElement;
    i18n.render(locale);
  });
}

// This is a <komoju-i18n> element that we use internally for displaying translated text
export default class KomojuI18nElement extends HTMLElement {
  static get observedAttributes() {
    return ['key'];
  }

  // Attribute: key
  // The key of the translation to display.
  get key() {
    return this.getAttribute('key');
  }
  set key(value) {
    this.setAttribute('key', value ?? '');
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback(name: string, _oldValue: string, _newValue: string) {
    if (name === 'key') this.render();
  }

  // Search up the DOM until we find a parent element with a locale attribute.
  findLocale() {
    let parent = this.parentElement;
    while (parent && !parent.getAttribute('locale')) {
      parent = parent.parentElement;
    }
    return parent?.getAttribute('locale') ?? defaultLanguage;
  }

  render(locale?: string) {
    if (!this.key) return;

    if (!locale) locale = this.findLocale();
    if (!Object.keys(window.komojuTranslations).includes(locale)) locale = defaultLanguage;

    const lang = locale.substring(0, 2);

    const message = window.komojuTranslations[lang][this.key];
    if (!message) {
      console.error(`KOMOJU bug: missing translation for key: ${this.key}`);
      return;
    }

    // Perform interpolation
    const matches = message.match(/%\{[\w-]+\}/g);
    if (matches) {
      let result = message;
      matches.forEach((match) => {
        const key = match.replace(/%{|}/g, '');
        const value = this.dataset[key];
        if (value) result = result.replace(match, value);
      });
      this.textContent = result;
      return;
    }

    this.textContent = message;
  }
}
